import React, { useRef, useState } from "react";
import AlertMessage from "../../../AlertMessage/AlertMessage";
import ConfirmPopup from "../../../ConfirmPopup/ConfirmPopup";
import { UpdateInvoiceStageAndArchiveStatusService } from "../../../../Services/InvoiceService/InvoiceService";
import { SupplierStatementArchiveRecord } from "../../../../Types/SupplierStatementArchive";

interface UnarchiveButtonProps {
  record: SupplierStatementArchiveRecord;
  onSuccess: () => void;
  onBeforeAction: (action: () => void) => void;
}

const UnarchiveButton: React.FC<UnarchiveButtonProps> = ({
  record,
  onSuccess,
  onBeforeAction,
}) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submissionInProgress = useRef(false);

  const submitUnarchive = async () => {
    if (submissionInProgress.current) return;

    submissionInProgress.current = true;
    setIsSubmitting(true);
    try {
      const result = await UpdateInvoiceStageAndArchiveStatusService({
        invoiceIds: [record.invoiceId],
        stageId: null,
        archiveStatus: "UnArchived",
      });
      if (!result.success) {
        throw new Error(result.message);
      }
      AlertMessage({ type: "success", text: "Supplier statement unarchived." });
      setOpen(false);
      onSuccess();
    } catch (error) {
      console.error("Failed to unarchive supplier statement:", error);
      AlertMessage({
        type: "error",
        text: "Something went wrong. The item could not be unarchived. Please try again.",
      });
    } finally {
      submissionInProgress.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="sv-action-btn sv-btn-archive"
        onClick={() => onBeforeAction(() => setOpen(true))}
      >
        <span className="sv-btn-text">Unarchive</span>
      </button>
      <ConfirmPopup
        blur
        isOpen={open}
        title="Unarchive Statement"
        message="Are you sure you want to unarchive this item?"
        confirmLabel={isSubmitting ? "Processing..." : "Unarchive"}
        cancelLabel="Cancel"
        confirmColor="var(--color-brand)"
        onConfirm={() => void submitUnarchive()}
        onCancel={() => setOpen(false)}
        confirmDisabled={isSubmitting}
      />
    </>
  );
};

export default UnarchiveButton;
